import gql from "graphql-tag";

export const GET_SAVED_CARD = gql`
    query savedCard {
        savedCard {
            id
            last4
            expMonth
            expYear
            name
            addressZip
            receiptInfo
        }
    }
`;
